import React from 'react'
import { useState } from 'react'
import NavLink from './NavLink'
import DisclosureItem from './DisclosureItem'
import { useKeyboardIndex } from './useKeyboardIndex'
import { useExpanded } from '../Core/useExpanded'

const DisclosureNavigationMenu = ({
    accessName,
    menuTree,
    onChangeMenuTree,
}) => {
    const [expandedId, toggleExpanded] = useExpanded()
    const indexLength = menuTree.length + menuTree.filter(i => i.children.length > 0).length
    let itemIndex = 0

    const handleEscape = () => toggleExpanded(false)

    const [index, setIndex, handleKeyDown, handleOnFocus] = useKeyboardIndex(indexLength, handleEscape)

    return (
        <nav aria-label={accessName} role="navigation">
            <ul className='access-disclosure-nav'>
                {menuTree.map((item, i) => {
                    const hasChildren = item.children.length > 0
                    const indexLink = itemIndex 
                    const indexButton = itemIndex + 1

                    itemIndex = itemIndex + (hasChildren ? 2 : 1) 

                    return (
                        <li key={item.id} className={hasChildren ? 'access-children' : 'access-no-children'}>
                            <NavLink
                                item={item}
                                hasFocus={index === indexLink}
                                handleKeyDown={handleKeyDown}
                                handleOnFocus={() => handleOnFocus(indexLink)}
                            />

                            {hasChildren && <DisclosureItem
                                item={item}
                                isExpanded={item.id === expandedId}
                                hasFocus={index === indexButton}
                                
                                onSetMainIndex={setIndex}
                                toggleExpanded={toggleExpanded}

                                handleMainKeyDown={handleKeyDown}
                                handleMainOnFocus={() => handleOnFocus(indexButton)}
                            />}
                        </li>
                    )
                })}
            </ul>
        </nav>

    )
}
export default DisclosureNavigationMenu
